<template>
    <div id="main-container">
        <div id="stencil">
            <div class="stencilInfo">
                <el-row>
                    <el-button class="wp100" @click="toDataList"><i class="el-icon-s-home"></i>
                        {{(mapType === 'example')?'首页':'返回列表'}}
                    </el-button>
                </el-row>
                <el-row>
                    <el-button class="wp100" type="success" @click="toPNGFun">导出图片</el-button>
                </el-row>
            </div>
            <div id="leftTool">
            </div>
        </div>
        <div id="graph-container"></div>

        <!--节点菜单-->
        <node-menu
            ref="nodeMenu"
            :checkLogin="checkLogin"
            :contextmenuCell="contextmenuCell">
        </node-menu>

        <!--操作指引-->
        <left-info></left-info>
    </div>
</template>

<script>
import {Graph, DataUri} from '@antv/x6'
import insertCss from 'insert-css'
import EventToolService from "../service/EventToolService";
import request from "../common/request";
import api from "../common/api";
import {mapState} from "vuex";
import NodeMenu from './NodeMenu.vue';
import StencilService from "../service/StencilService";
import LeftInfo from './LeftInfo.vue';

insertCss(`
    .x6-widget-stencil  {
      background-color: #fff;
    }
    .x6-widget-stencil-title {
      background-color: #fff;
      display:none;
    }
    .x6-widget-stencil-group-title {
      background-color: #fff !important;
      display:none;
    }
    .x6-widget-transform {
      margin: -1px 0 0 -1px;
      padding: 0px;
      border: 1px solid #239edd;
    }
    .x6-widget-transform > div {
      border: 1px solid #239edd;
    }
    .x6-widget-transform > div:hover {
      background-color: #3dafe4;
    }
    .x6-widget-transform-active-handle {
      background-color: #3dafe4;
    }
    .x6-widget-transform-resize {
      border-radius: 0;
    }

    //框选样式
    .x6-widget-selection-inner {
    box-sizing: content-box !important;
    margin-top: -8px;
    margin-left: -8px;
    padding-right: 12px;
    padding-bottom: 12px;
    border: 2px solid #feb663;
    box-shadow: 2px 2px 5px #d3d3d3;
}
    .x6-widget-selection-box {
    box-sizing: content-box !important;
    margin-top: -4px;
    margin-left: -4px;
    padding-right: 4px;
    padding-bottom: 4px;
    border: 2px dashed #feb663;
    box-shadow: 2px 2px 5px #d3d3d3;
    }
  `)


export default {
    components: {LeftInfo, NodeMenu},
    name: "MapTool",
    props: {
        checkLogin: {//登录
            type: Boolean,
            default: false
        },
        mapType: {
            type: String,
            default: 'example' //example:案例  user:个人  open:开放列表
        }
    },
    data: function () {
        return {
            graph: {},
            socket: null,
            nowAddNodeId: '',//当前新增节点ID
            dataListId: '',
            dataListName: '',
            nodes: [],
            contextmenuCell: {},  //右键菜单节点
        }
    },
    computed: {
        ...mapState([
            "baseInfo",
        ]),
        userId: function () {
            if (!this.checkLogin) return ""
            return this.baseInfo.userId
        }
    },
    created() {
        this.dataListId = this.$route.params.id
        this.dataListName = this.$route.params.name
        this.$nextTick(() => {
            if (this.dataListName !== '') document.title = this.dataListName + '-事件风暴'
        })
    },
    mounted() {
        this.$nextTick(() => {
            this.mapInit()

            if (this.checkLogin) {
                this.socket = EventToolService.tcpService(this)
            }
            this.getNodes()
        })
    },
    methods: {
        mapInit: function () {
            const container = document.getElementById('graph-container')
            this.graph = new Graph({
                container: container,
                panning: true, //画布平移
                snapline: true, //对齐线，默认禁用。
                selecting: {
                    enabled: true,
                    multiple: true,
                    rubberband: true, //是否启用框选
                    showNodeSelectionBox: true, //是否显示节点的选择框
                    modifiers: 'shift', //按shift 才启用框选
                },
                grid: true,
                keyboard: true, //快捷键
                clipboard: { //剪贴板
                    enabled: true,
                },
                width: container.clientWidth,
                height: window.innerHeight,
                // resizing: {
                //     enabled: true,
                // },
            })

            let that = this

            //左侧
            StencilService.leftMenuInit(this.graph)

            //画布点击
            this.graph.on('blank:click', () => {
                this.contextmenuHide() //隐藏菜单
                this.graph.enableKeyboard() //启用键盘事件
            })
            //画布右击
            this.graph.on('blank:contextmenu', () => {
                this.contextmenuHide() //隐藏菜单
                this.graph.enableKeyboard() //启用键盘事件
            })

            //编辑
            this.graph.on('cell:dblclick', ({cell, e}) => {
                this.graph.disableKeyboard() //禁用键盘事件
                const isNode = cell.isNode()
                const name = cell.isNode() ? 'node-editor' : 'edge-editor'
                cell.removeTool(name)
                if (name === 'node-editor') {
                    cell.addTools({
                        name,
                        args: {
                            event: e,
                            attrs: {
                                backgroundColor: isNode ? '#EFF4FF' : '#FFF',
                                color: "#333333",
                            },
                            getText({cell}) {
                                return cell.label
                            },
                            setText({cell, value}) {
                                cell.label = value
                                if (that.checkLogin) {
                                    let nodeToInfo = that.nodeToInfoWithLabel(cell, value)
                                    that.emitUpdateNode(nodeToInfo)
                                }
                            },
                        },
                    })
                } else {
                    cell.addTools({
                        name,
                        args: {
                            event: e,
                            attrs: {
                                backgroundColor: isNode ? '#EFF4FF' : '#FFF',
                                color: "#333333",
                            },
                            getText({cell}) {
                                return cell.label
                            },
                            setText({cell, value}) {
                                cell.setLabels(value)
                            },
                        },
                    })
                }
            })

            this.graph.on('cell:click', ({cell, e}) => {
                this.graph.enableKeyboard() //启用键盘事件
            })
            this.graph.on('cell:selected', (args) => {
                this.graph.enableKeyboard() //启用键盘事件
            })

            //右键菜单
            this.graph.on('node:contextmenu', ({cell, e}) => {
                const {x, y} = cell.position()
                const {width} = cell.getSize()

                const realPosition = this.graph.localToPage(x, y);
                this.$refs.nodeMenu.showNodeMenu(realPosition, width)
                this.contextmenuCell = cell
            })


            //新增节点  （仅当 cell 是节点时才触发）
            this.graph.on('node:added', ({node}) => {
                let nodeInfo = this.nodeToInfo(node)
                this.emitAddNode(nodeInfo)
            })

            this.graph.on('node:removed', ({node}) => {
                let nodeInfo = this.nodeToInfo(node)
                this.emitDeleteNode(nodeInfo)
            })

            //移动结束
            this.graph.on('node:moved', ({node}) => {
                let nodeInfo = this.nodeToInfo(node)
                this.emitUpdateNode(nodeInfo)
            })

            this.graph.bindKey(['ctrl+c', 'command+c'], () => {
                const cells = this.graph.getSelectedCells()
                if (cells.length) {
                    this.graph.copy(cells)
                }
                return false
            })

            this.graph.bindKey(['ctrl+v', 'command+v'], () => {
                if (!this.graph.isClipboardEmpty()) {
                    const cells = this.graph.paste({offset: 32})
                    this.graph.cleanSelection() //清空选区
                    this.graph.select(cells)
                }
                return false
            })

            this.graph.bindKey(['ctrl+x', 'command+x', 'delete'], () => {
                const cells = this.graph.getSelectedCells()
                if (cells.length) {
                    this.graph.cut(cells)
                }
                return false
            })

            //根据节点的包围盒渲染一个包围节点的矩形。注意，该工具仅仅渲染一个矩形，不带任何交互
            // this.graph.on('node:mouseenter', ({node}) => {
            //     node.addTools({
            //         name: 'boundary',
            //         args: {
            //             padding: 2,
            //             attrs: {
            //                 fill: '#7c68fc',
            //                 stroke: '#333',
            //                 'stroke-width': 1,
            //                 'fill-opacity': 0.2,
            //             },
            //         },
            //     })
            // })
            // this.graph.on('node:mouseleave', ({node}) => {
            //     node.removeTools()
            // })

        },

        getNodes: function () {
            //example:案例  user:个人  open:开放列表
            if (this.mapType === 'example') {
                this.graph.fromJSON({
                    nodes: EventToolService.exampleNodes(),
                    options: {slient: true}
                })//当 options.slient 为 true 时，不触发 cell:added、node:added 和 edge:added 事件和画布重绘。

                this.graph.centerContent() //平移图到中心将对齐到画布中心
                return
            }

            let url = (this.mapType === 'user') ? api.ItemList : api.ItemListOpen
            request.post(url, {dataListId: this.dataListId}).then((data) => {
                this.graph.fromJSON({
                    nodes: data,
                    options: {slient: true}
                })//当 options.slient 为 true 时，不触发 cell:added、node:added 和 edge:added 事件和画布重绘。

                this.graph.centerContent() //平移图到中心将对齐到画布中心
            }).catch(() => {
                this.$message.error("获取数据失败")
            });
        },
        //节点信息
        nodeToInfo(node) {
            const {x, y} = node.position()
            return {
                id: node.id,
                label: node.attrs.text.text,
                shape: node.shape,
                x: parseInt(x),
                y: parseInt(y),
                zIndex: node.zIndex,
                dataListId: this.dataListId,
                userId: this.userId,
            }
        },
        //节点信息-label修改
        nodeToInfoWithLabel(node, label) {
            const {x, y} = node.position()
            return {
                id: node.id,
                label: label,
                shape: node.shape,
                x: parseInt(x),
                y: parseInt(y),
                zIndex: node.zIndex,
                dataListId: this.dataListId,
                userId: this.userId,
            }
        },
        //socket  addNode
        emitAddNode: function (nodeInfo) {
            this.contextmenuHide()

            if (!this.checkLogin) return
            let socket0 = this.socket.emit("addNode", JSON.stringify(nodeInfo));
            if (!socket0.connected) {
                this.$message.error("连接断开，请重试")
                return;
            }
            this.$set(this, 'nowAddNodeId', nodeInfo.id)
        },
        emitUpdateNode: function (nodeInfo) {
            this.contextmenuHide()
            if (this.checkLogin) this.socket.emit("updateNode", JSON.stringify(nodeInfo));
        },
        emitDeleteNode: function (nodeInfo) {
            this.contextmenuHide()
            if (this.checkLogin) this.socket.emit("deleteNode", JSON.stringify(nodeInfo));
        },

        //右键菜单隐藏
        contextmenuHide: function () {
            this.$refs.nodeMenu.hideNodeMenu();
        },
        toDataList: function () {
            //example:案例  user:个人  open:开放列表

            let name = ''
            switch (this.mapType) {
                case 'user':
                    name = 'DataList'
                    break;
                case 'open':
                    name = 'DataListOpen'
                    break;
                default:
                    name = 'Home'
            }

            this.$router.push({name: name})
            if (this.checkLogin) this.socket.close()
        },
        toPNGFun: function () {
            this.graph.toPNG((dataUri) => {
                // 下载
                DataUri.downloadDataUri(dataUri, 'eventstorming.png')
            }, {
                padding: {
                    top: 20,
                    right: 30,
                    bottom: 40,
                    left: 50,
                },
                backgroundColor: "#f1f3f4",
                quality: 1
            })
        },
    }
}
</script>

<style scoped lang="scss">
#main-container {
    display: flex;
    position: relative;
}

#stencil {
    width: 180px;
    border-right: 1px solid #dfe3e8;

    .stencilInfo {
        width: 100%;
        height: 80px;
    }

    #leftTool {
        width: 100%;
        height: calc(100% - 80px);
        position: relative;
    }
}

#graph-container {
    width: calc(100% - 180px);
    height: 100%;
}
</style>
